<template>
  <div v-if="data">
    <div class="flex justify-between">
      <div><Option :items="items" :option.sync="current_option"></Option></div>
      <div class="space-x-8 ddd">
        <span @click="allRead">{{ $t("批量已读") }}</span>
      </div>
    </div>
    <div class="mt-4">
      <List
        :span="1"
        :data="data"
        class="text-left"
        v-slot="{ item }"
        v-if="data.total"
      >
        <Msg :item="item" @readMessage="readMessage"></Msg>
      </List>
      <img src="@/assets/image/暂无数据.png" class="m-auto mt-30" v-else />
      <div class="mt-13">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="data.total"
          :page-size="5"
          :current-page.sync="current_page"
          :hide-on-single-page="true"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import Option from "@/components/mine/message/option.vue";
import List from "@/components/base/list.vue";
import Msg from "@/components/mine/message/msg.vue";
import { onMounted, reactive, ref, watch } from "@vue/composition-api";
import { equals } from "ramda";
export default {
  components: { Option, List, Msg },
  setup(props, ctx) {
    const data = ref();
    const getMessageList = async () => {
      const notice = {
        通知消息: "system",
        订单消息: "trade",
      };
      const query = {
        size: 5,
        page: current_page.value,
        tag: notice[current_option.value],
      };
      // ctx.root.$doing()
      const res = await ctx.root.$callapi("user/getMessageList", query);
      // ctx.root.$done()
      data.value = res.data;
      // console.log("data.value:",data.value);
    };
    onMounted(async () => {
      getMessageList();
    });
    const _callapi = (query) =>
      ctx.root.$callapi("user/getMessageList", query).then((v) => {
        data.value = v.data;
        // console.log("data.value11:",data.value);
      });
    const items = reactive({
      通知消息: (_page = 1) =>
        _callapi({ page: _page, size: 5, tag: "system" }),
      订单消息: (_page = 1) => _callapi({ page: _page, size: 5, tag: "trade" }),
    });
    //批量已读
    const allRead = async () => {
      ctx.root.$doing();
      const arr = data.value.items.map((item) => item.id);
      const res = await ctx.root.$callapi("user/readMessage", {
        mids: arr,
      });
      ctx.root.$done();
      if (res.code == 0) {
        getMessageList();
      }
      // 更新未读消息数
        const result = await ctx.root.$callapi("user/getMessageCount");
        if(result){
          // console.log("countttt:", result.data.count);
           ctx.root.$store.commit("SET_MESSAGECOUNT", result.data.count);
        }
    };
    const current_page = ref(1);
    const current_option = ref("通知消息");

    watch(
      [current_option, current_page],
      ([new_option, new_page], [prev_option, prev_page]) => {
        if (equals(new_option, prev_option)) {
          items[new_option](new_page);
        } else {
          items[new_option](1);
          current_page.value = 1;
        }
      }
    );
    const readMessage = async (...args) => {
      // console.log("args:",args)
      if (args[1] && current_option.value == "订单消息") {
        ctx.root.$doing();
        const o_id = args[1].slice(args[1].indexOf("=") + 1);
        if (args[2]) {
          // ctx.root.$done();
          // ctx.root.$router.push({
          //   name: "OrderDetail",
          //   params: { id: o_id },
          // });
          // console.log("args[1]:",args[1]);
          if (args[1].substr(0, 17) == "/pages/sup/detail"){
            console.log(1111);
             ctx.root.$done();
              ctx.root.$router.push({
                name: "SupOrderDetail",
                params: { id: o_id, oid:o_id },
              });
          }else{
            console.log(2222);
            ctx.root.$done();
            ctx.root.$router.push({
              name: "OrderDetail",
              params: { id: o_id, oid:o_id },
            });
          }
        } else {
          ctx.root.$done();
          await ctx.root.$callapi("user/updateMessageStatus", {
            m_id: args[0],
          });
          if (args[1].substr(0, 17) == "/pages/sup/detail"){
            // console.log(1111);
             ctx.root.$done();
              ctx.root.$router.push({
                name: "SupOrderDetail",
                params: { id: o_id, oid:o_id },
              });
          }else{
            console.log(2222);
            // ctx.root.$done();
            ctx.root.$router.push({
              name: "OrderDetail",
              params: { id: o_id },
            });
          }
          // ctx.root.$router.push({
          //   name: "OrderDetail",
          //   params: { id: o_id },
          // });
        }
      } else {
        if (!args[2]) {
          ctx.root.$doing();
          const res = await ctx.root.$callapi("user/updateMessageStatus", {
            m_id: args[0],
          });
          if (res.code == 0) {
            getMessageList();
          }
          ctx.root.$done();
        }
      }
      // 更新未读消息数
        const result = await ctx.root.$callapi("user/getMessageCount");
        if(result){
          ctx.root.$store.commit("SET_MESSAGECOUNT", result.data.count);
          
        }
    };
    return {
      items,
      data,
      current_page,
      current_option,
      readMessage,
      allRead,
    };
  },
};
</script>
<style scoped lang="scss">
.ddd > span {
  --tw-bg-opacity: 1;
  background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
  cursor: pointer;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --tw-text-opacity: 1;
  color: rgba(107, 114, 128, var(--tw-text-opacity));
}
</style>
